const profileApi = {
  signOut: '/sale/api/login/logout',
  getMemberInfo: '/api/member/get',
  memberInfoUpdate: '/api/member/update',
  pointConfig: '/sale/api/points/rule',
  pointHistory: '/sale/api/points/history',
  getPointRuleAndHistoryV2: '/sale/api/points/rule-and-history/v2',
  promotionData: '/coupon/v1/available-past',
  notificationData: '/api/notice/search/by-receiver',
  getLevelBenefits: '/api/standard/member/level/benefit/list',
  addressUpdate: '/api/member/address/update',
  addressSave: '/api/member/address/save',
  getMemberAddress: '/api/member/address/default',
  getLevelIntroduction: '/api/standard/member/level/introduction',
  getGiftCardListData: '/api/gift/card/list',
  saveDefaultGiftCard: '/api/gift/card/set-default-pay-card',
  getBindCreditCard: '/api/member/card/creditcard/list',
  removeBindCreditCard: '/api/member/card/creditcard/remove',
  getPayConfig: '/sale/api/payment/getGatewayConfig',
  bindCreditCardStripe: '/api/member/card/creditcard/bind',
  createSetupIntent: '/sale/api/payment/card/createSetupIntent',
  // 新
  getBenefits: '/sale/api/member/level/info',
  deleteAddress: '/sale/api/address/delete'
}

export default profileApi;
